import { makeStyles } from "@material-ui/core"
import { useContext, useState } from "react"
import PhoneInput from "react-phone-input-2"
import pt from "react-phone-input-2/lang/pt.json"
import "react-phone-input-2/lib/material.css"
import useParametros from "../contexts/ParametrosContext"
import SiteContext from "../contexts/SiteContext"
import { useTextos } from "../contexts/TextosContext"

const useStyles = makeStyles({
    campoTelefone: {
        minHeight: "3.5rem",
        "& > .form-control": {
            minHeight: "3.5rem",
            width: "100% !important",
        },
        "& .special-label": {
            color: "rgba(0, 0, 0, 0.54)",
            left: "8px !important",
        },
    },
})

const TelefoneInputField = props => {
    const { usuarioLogado } = useContext(SiteContext)
    const textos = useTextos()
    const parametros = useParametros()
    const classes = useStyles()

    const [telefone, setTelefone] = useState(
        props.telefoneRef?.current ?? usuarioLogado?.cliente?.telefone?.replace(/\D/g, "")
    )
    const [ddi, setDdi] = useState(parametros.PUBLIC_DDI_PADRAO?.replace("+", "") ?? "55")

    const handleChangeTelefone = (telefone, pais) => {
        const telefoneSemDDI = telefone.slice(pais.dialCode.length).trim().replaceAll(" ", "")

        setTelefone(telefoneSemDDI)
        handleChangeCodigoPais(pais.dialCode)

        if (props.telefoneRef) props.telefoneRef.current = telefoneSemDDI
    }

    const handleChangeCodigoPais = ddi => {
        setDdi(ddi)

        if (props.ddiRef) props.ddiRef.current = ddi
    }

    const getDefaultCountry = () => {
        const language = navigator.language ?? navigator.userLanguage

        const codigoPaisLanguage = language.includes("-")
            ? language.split("-")[1].toLowerCase()
            : language.toLowerCase()

        return codigoPaisLanguage ?? parametros.PUBLIC_CODIGO_PAIS ?? "fr"
    }

    return (
        <>
            <PhoneInput
                value={"+" + ddi + telefone}
                onChange={handleChangeTelefone}
                country={getDefaultCountry()}
                enableSearch
                containerClass={classes.campoTelefone}
                localization={pt}
                specialLabel={textos.telefone}
                searchPlaceholder=""
                masks={{ br: "(..) .....-...." }}
                inputProps={{ id: props.id ?? "telefone-input" }}
                isValid={(telefone, pais) =>
                    telefone.length === pais.format.replace(/[^.]/g, "").length
                }
            />
            <input id="ddi-select" value={ddi} readOnly style={{ display: "none" }} />
        </>
    )
}

export default TelefoneInputField
